import {useEffect,useState} from 'react'
import {helpPosterAvailable,helpVideoAvailable,helpVideoPaths} from './video'

export function HelpVideo({id,title}:{id:string;title:string}){
  const [ready,setReady]=useState<string|null>(null)
  const [poster,setPoster]=useState<string|null>(null)
  useEffect(()=>{
    const controller=new AbortController();setReady(null);setPoster(null)
    void (async()=>{
      if(!await helpVideoAvailable(id,controller.signal)||controller.signal.aborted)return
      setReady(id)
      if(await helpPosterAvailable(id,controller.signal)&&!controller.signal.aborted)setPoster(id)
    })()
    return ()=>controller.abort()
  },[id])
  if(ready!==id)return null
  const paths=helpVideoPaths(id)
  return <section className="context-help-video" aria-label={`Captioned video: ${title}`}>
    <h4>Watch this guide</h4>
    <video controls playsInline preload="none" poster={poster===id?paths.poster:undefined} aria-label={title} onError={()=>setReady(null)}>
      <source src={paths.video} type="video/mp4"/>
      <track kind="captions" src={paths.captions} srcLang="en" label="English captions" onError={()=>setReady(null)}/>
    </video>
  </section>
}
